export default __webpack_public_path__ + "static/media/two.1203ad52.svg";